import { BqButton, BqDropdown, BqOptionList } from '@beeq/react'
import styled from 'styled-components'

export const StyledBqButton = styled(BqButton)`
  ::part(button) {
    padding: var(--bq-spacing-s);
  }
  & span {
    margin: 0 var(--bq-spacing-xs2);
  }
`

export const StyledBqDropdown = styled(BqDropdown)`
  line-height: var(--bq-font-line-height--regular);
  ::part(panel) {
    width: 258px;
    box-shadow: 0px 10px 48px -16px rgba(0, 0, 0, 0.4);
  }
`

export const OptionList = styled(BqOptionList)`
  text-align: left;
`
